import React from 'react';
export class LoadingBlock extends React.PureComponent {
    render() {
        return <div className='cfm_load_block' style={this.props.style}/>;
    }
}
export class LoadingTextRow extends React.PureComponent {
    render() {
        return <div className='cfm_load_text' style={this.props.style}/>;
    }
}
export class LoadingRoundShape extends React.PureComponent {
    render() {
        return <div className='cfm_load_round' style={this.props.style}/>;
    }
}
export class LoadingRectShape extends React.PureComponent {
    render() {
        return <div className='cfm_load_rect' style={this.props.style}/>;
    }
}
export class LoadingImgBlock extends React.PureComponent {
    render() {
        return <div className='cfm_load_img' style={this.props.style}><span>{this.props.text || 'CLUB FACTORY'}</span></div>;
    }
}
export class LoadingMediaBlock extends React.PureComponent {
    render() {
        return (<div style={this.props.style} className='cfm_load_media'>
        <div>
          <LoadingImgBlock text={this.props.imgText}/>
        </div>
        <div className='cfm_load_media_right'>
          <LoadingTextRow />
          <LoadingTextRow />
          <LoadingTextRow />
          <LoadingTextRow />
        </div>
      </div>);
    }
}
const Placeholders = {
    cfBlock: LoadingBlock,
    cfText: LoadingTextRow,
    cfRound: LoadingRoundShape,
    cfRect: LoadingRectShape,
    cfImg: LoadingImgBlock,
    cfMedia: LoadingMediaBlock,
};
export default Placeholders;



// WEBPACK FOOTER //
// ./components/loading-placeholder/Placeholders.tsx